module.exports = __webpack_public_path__ + "img/100bit_air_bridge.2b9f61f1.svg";